import React from "react";
import ContextBased, {needle} from "./ContextBased";

export default (Component: React.Component|React.FunctionComponent, config?: {needle?: needle}) => React.forwardRef((props: {needle?: needle}, ref) => {
    return <ContextBased needle={config?.needle || props?.needle}>
        <Component ref={ref} {...props} />
    </ContextBased>
});